<template>
  <v-app class="landing-layout">
    <v-app-bar
      app
      flat
      color="rgba(5, 5, 5, 0.8)"
      class="border-bottom-dark blur-nav"
      dark
    >
      <v-container class="d-flex align-center py-0">
        <div
          class="d-flex align-center cursor-pointer logo-hover"
          @click="$vuetify.goTo(0)"
        >
          <v-img
            src="@/assets/bear-face-icon-2.png"
            max-height="40"
            max-width="40"
            contain
            class="mr-3"
          ></v-img>
          <span class="text-h6 font-weight-black white--text tracking-wider"
            >LEGOR<span class="brand-text">ERP</span></span
          >
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-md-flex align-center mr-6">
          <v-btn text class="text-capitalize" @click="$vuetify.goTo('#modulos')"
            >Módulos</v-btn
          >
          <v-btn
            text
            class="text-capitalize"
            @click="$vuetify.goTo('#nosotros')"
            >Nosotros</v-btn
          >
          <v-btn
            text
            class="text-capitalize"
            @click="$vuetify.goTo('#contacto')"
            >Contacto</v-btn
          >
        </div>
        <v-btn
          depressed
          color="#BA6B30"
          class="font-weight-bold px-6 rounded-lg hover-elevate shadow-orange"
          to="/login"
          >Entrar</v-btn
        >
      </v-container>
    </v-app-bar>

    <v-main>
      <section
        class="hero-section relative overflow-hidden d-flex align-center"
      >
        <div class="blob-accent top-left"></div>
        <v-container class="relative z-10">
          <v-row align="center">
            <v-col cols="12" md="6" class="pa-8 pa-md-16 fade-in-left">
              <v-chip
                label
                color="rgba(186, 107, 48, 0.15)"
                text-color="#F5A623"
                class="mb-6 font-weight-black border-glass px-4"
                >CLOUD NATIVE - MULTI SUCURSAL</v-chip
              >
              <h1 class="text-h2 font-weight-black mb-6 lh-tight white--text">
                Gestión total en <br /><span class="brand-text"
                  >un solo lugar.</span
                >
              </h1>
              <p
                class="text-h6 grey--text text--lighten-2 mb-10 font-weight-light"
              >
                Controla inventarios, ventas y finanzas en tiempo real. La
                plataforma integral diseñada para la escalabilidad de tu
                negocio.
              </p>
              <div class="d-flex gap-6">
                <v-btn
                  x-large
                  color="#BA6B30"
                  class="px-10 py-8 rounded-xl font-weight-bold hover-elevate shadow-orange"
                  >Probar Gratis</v-btn
                >
              </div>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="d-none d-md-flex justify-center fade-in-right relative"
            >
              <div class="visual-wrapper">
                <div class="floating-badge badge-1 border-glass">
                  <v-icon color="#4CAF50" small class="mr-2"
                    >mdi-cloud-check</v-icon
                  >
                  <span class="white--text font-weight-black"
                    >Cloud Sync On</span
                  >
                </div>
                <div class="floating-badge badge-2 border-glass">
                  <div class="d-flex flex-column">
                    <span class="grey--text text-overline lh-1"
                      >Sucursales</span
                    >
                    <span class="brand-text font-weight-black text-h6"
                      >Multi-Node</span
                    >
                  </div>
                </div>
                <div class="glass-preview-card border-glass">
                  <div class="skeleton-bar medium mb-8"></div>
                  <v-row
                    ><v-col v-for="i in 3" :key="i" cols="4"
                      ><div
                        class="skeleton-box border-glass pulse-slow"
                      ></div></v-col
                  ></v-row>
                  <div class="mt-auto d-flex justify-space-between align-end">
                    <div class="chart-mockup d-flex gap-2">
                      <div
                        v-for="h in [40, 70, 55, 90, 65]"
                        :key="h"
                        class="chart-bar animated-bar"
                        :style="{ height: h + 'px' }"
                      ></div>
                    </div>
                    <v-icon color="rgba(186, 107, 48, 0.3)" size="70"
                      >mdi-monitor-dashboard</v-icon
                    >
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section
        class="py-12 border-top-dark border-bottom-dark overflow-hidden bg-black"
      >
        <div class="marquee-container">
          <div class="marquee-content">
            <div v-for="n in 3" :key="n" class="d-flex align-center">
              <span
                v-for="marca in marcas"
                :key="marca"
                class="mx-12 grey--text text--darken-2 text-h4 font-weight-black tracking-widest text-uppercase italic"
              >
                {{ marca }}
              </span>
            </div>
          </div>
        </div>
      </section>

      <section id="modulos" class="py-16">
        <v-container>
          <div class="text-center mb-16">
            <h2 class="text-h3 font-weight-black white--text mb-4">
              Módulos <span class="brand-text">Core</span>
            </h2>
            <p class="grey--text text-h6 font-weight-light">
              El motor central de tu operativa: Inteligencia, Sincronización y
              Control Total.
            </p>
          </div>
          <v-row>
            <v-col
              v-for="mod in listaModulos"
              :key="mod.title"
              cols="12"
              sm="6"
              lg="4"
            >
              <v-card
                class="module-card border-glass h-100 pa-8"
                dark
                color="rgba(255,255,255,0.02)"
              >
                <v-avatar
                  color="rgba(186, 107, 48, 0.1)"
                  size="50"
                  class="mb-6 border-glass"
                >
                  <v-icon color="#F5A623">{{ mod.icon }}</v-icon>
                </v-avatar>
                <h3 class="text-h5 font-weight-bold mb-4">{{ mod.title }}</h3>
                <v-list
                  dense
                  bg-color="transparent"
                  class="bg-transparent pa-0"
                >
                  <v-list-item
                    v-for="item in mod.sub"
                    :key="item"
                    class="px-0 min-h-0 mb-1"
                  >
                    <v-icon x-small color="#BA6B30" class="mr-2"
                      >mdi-circle-medium</v-icon
                    >
                    <span class="grey--text text-body-2">{{ item }}</span>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="nosotros" class="py-16 bg-visual relative">
        <v-container>
          <v-row align="center">
            <v-col cols="12" md="6" class="pa-10">
              <h2 class="text-h3 font-weight-black white--text mb-6">
                Arquitectura Cloud <br />
                <span class="brand-text">para negocios modernos.</span>
              </h2>
              <p class="grey--text text-h6 font-weight-light lh-relaxed">
                Legor ERP no es solo un sistema local. Es una solución de alto
                rendimiento diseñada para manejar múltiples sucursales y cajas
                de forma centralizada, permitiendo que tu empresa crezca sin
                límites técnicos.
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-row>
                <v-col v-for="val in valores" :key="val.title" cols="6">
                  <div
                    class="pa-6 border-glass rounded-xl h-100 bg-black-light"
                  >
                    <div class="brand-text text-h4 font-weight-black mb-2">
                      {{ val.val }}
                    </div>
                    <div class="white--text font-weight-bold mb-1">
                      {{ val.title }}
                    </div>
                    <div class="grey--text text-caption">{{ val.desc }}</div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="contacto" class="py-16">
        <v-container>
          <v-card
            class="border-glass rounded-xl overflow-hidden"
            color="rgba(255,255,255,0.02)"
            dark
          >
            <v-row no-gutters>
              <v-col cols="12" md="5" class="pa-10 bg-visual">
                <h2 class="text-h4 font-weight-black mb-6">
                  Hablemos de tu <span class="brand-text">proyecto.</span>
                </h2>
                <div class="d-flex align-center mb-6">
                  <v-icon color="#BA6B30" class="mr-4">mdi-email-outline</v-icon
                  ><span>soporte@legorerp.com</span>
                </div>
                <div class="d-flex align-center mb-6">
                  <v-icon color="#BA6B30" class="mr-4">mdi-cloud-outline</v-icon
                  ><span>Disponibilidad 24/7/365</span>
                </div>
              </v-col>
              <v-col cols="12" md="7" class="pa-10">
                <v-form>
                  <v-row>
                    <v-col cols="6"
                      ><v-text-field
                        label="Nombre"
                        outlined
                        dense
                        color="#BA6B30"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="6"
                      ><v-text-field
                        label="Empresa"
                        outlined
                        dense
                        color="#BA6B30"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12"
                      ><v-text-field
                        label="Email"
                        outlined
                        dense
                        color="#BA6B30"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12"
                      ><v-textarea
                        label="Mensaje"
                        outlined
                        dense
                        color="#BA6B30"
                        rows="3"
                      ></v-textarea
                    ></v-col>
                    <v-col cols="12"
                      ><v-btn
                        x-large
                        block
                        color="#BA6B30"
                        class="font-weight-bold rounded-lg shadow-orange"
                        >Enviar Solicitud</v-btn
                      ></v-col
                    >
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </section>
    </v-main>

    <v-footer
      padless
      color="#050505"
      class="py-8 border-top-dark text-center"
      dark
    >
      <v-container
        ><span class="grey--text text-caption"
          >© {{ new Date().getFullYear() }} LEGOR ERP - CLOUD BUSINESS
          MANAGEMENT.</span
        >
        <div class="grey--text text-caption mt-1">
          Legorsoft — servicio de Lucas Gonzalez Rover · Villa María, Córdoba, Argentina
        </div></v-container
      >
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "LandingPage",
  data: () => ({
    marcas: ["Venecia", "Cruachan", "Hipercotillón"],
    valores: [
      { val: "100%", title: "Seguridad", desc: "Encriptación Bancaria." },
      { val: "24/7", title: "Acceso", desc: "Disponibilidad Cloud." },
      {
        val: "Global",
        title: "Alcance Internacional",
        desc: "De Villa María para el mundo.",
      },

      {
        val: "Multi",
        title: "Sucursales",
        desc: "Gestión de múltiples cajas.",
      },
    ],
    listaModulos: [
      {
        title: "Ventas (POS)",
        icon: "mdi-cart-outline",
        sub: [
          "Punto de venta ágil e intuitivo",
          "Gestión de clientes",
          "Control por sucursales",
          "Devoluciones y cierres de caja",
        ],
      },
      {
        title: "Compras",
        icon: "mdi-bag-checked",
        sub: [
          "Gestión de proveedores",
          "Órdenes de compra",
          "Historial y seguimiento",
          "Reportes clave",
        ],
      },
      {
        title: "Inventario",
        icon: "mdi-package-variant",
        sub: [
          "Control de stock en tiempo real",
          "Gestión multi-sucursal",
          "Movimientos y ajustes",
          "Alertas de stock bajo",
        ],
      },
      {
        title: "Gastos",
        icon: "mdi-cash-register",
        sub: [
          "Registro organizado por sucursal",
          "Categorías personalizadas",
          "Reportes operativos",
        ],
      },
      {
        title: "Contabilidad",
        icon: "mdi-calculator",
        sub: [
          "Libro diario y asientos automáticos",
          "Balances y reportes contables",
          "Integración con ventas y compras",
        ],
      },
      {
        title: "Facturación",
        icon: "mdi-file-document",
        sub: [
          "Emisión y gestión de comprobantes",
          "Notas de crédito",
          "Configuración fiscal simplificada",
        ],
      },
    ],
  }),
};
</script>

<style scoped>
/* GENERAL */
.landing-layout {
  background: #050505 !important;
  font-family: "Inter", sans-serif;
}
.brand-text {
  background: linear-gradient(135deg, #ba6b30 0%, #f5a623 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.hero-section {
  min-height: 85vh;
}
.border-glass {
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
}
.border-top-dark {
  border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
}
.border-bottom-dark {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
}
.bg-visual {
  background: radial-gradient(circle at 50% 50%, #121212 0%, #050505 100%);
}
.bg-black-light {
  background: rgba(255, 255, 255, 0.02);
}

/* MARQUEE */
.marquee-container {
  display: flex;
  overflow: hidden;
  gap: 2rem;
  padding: 10px 0;
}
.marquee-content {
  display: flex;
  flex-shrink: 0;
  min-width: 100%;
  animation: scroll 20s linear infinite;
}
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-33.33%);
  }
}

/* HERO ANIMATIONS */
.visual-wrapper {
  position: relative;
  padding: 50px;
}
.floating-badge {
  position: absolute;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(15px);
  border-radius: 18px;
  z-index: 20;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  transition: all 0.6s ease;
}
.badge-1 {
  top: 0%;
  left: -5%;
  animation: floatY 4s infinite ease-in-out;
}
.badge-2 {
  bottom: 5%;
  right: -5%;
  animation: floatY 5s infinite ease-in-out reverse;
}

@keyframes floatY {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}

.glass-preview-card {
  width: 440px;
  height: 500px;
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(30px);
  border-radius: 40px;
  padding: 40px;
  transform: perspective(1000px) rotateY(-15deg);
  transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.visual-wrapper:hover .glass-preview-card {
  transform: perspective(1000px) rotateY(-2deg);
}
.visual-wrapper:hover .floating-badge {
  border-color: #ba6b30 !important;
}

/* UTILS */
.chart-bar {
  width: 12px;
  background: #ba6b30;
  border-radius: 4px;
  transition: all 0.4s;
}
.visual-wrapper:hover .chart-bar {
  background: #f5a623;
}
.module-card {
  transition: all 0.3s ease !important;
  border-radius: 24px !important;
}
.module-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: #ba6b30 !important;
}
.shadow-orange:hover {
  box-shadow: 0 10px 30px rgba(186, 107, 48, 0.4) !important;
}
.blob-accent {
  position: absolute;
  width: 600px;
  height: 600px;
  background: #ba6b30;
  filter: blur(200px);
  opacity: 0.1;
  top: -100px;
  left: -100px;
}
.cursor-pointer {
  cursor: pointer;
}
.gap-6 {
  gap: 1.5rem;
}
.lh-relaxed {
  line-height: 1.8;
}
</style>